export const getWidgetContainerSelector = (): string => {
  return (
    (window.location.href.indexOf('/customer/transport_request') > -1 ? '.internal-widget' : '') +
    '[data-brenger-tr-widget]'
  );
};
